import service from './server'
import request from "@/utils/newServer";
export function queryApi  (reqParam, type, istry, isJob, isLog, isRpt){
    
    if(istry){
        return request({
			url: reqParam.customUrl ?  reqParam.customUrl : '/iiot/doEvent/'+reqParam.url,
            method: 'post',
            data: {
                num:0,
                "id": "99u8239",
                "data": reqParam.data
            }
        })
    }else{
        // 判断reqParam.data.baseUrl前四位是否是/pox
        let baseUrl = process.env.VUE_APP_BASE_URL;
        if (isJob) {
            baseUrl = process.env.VUE_APP_JOB_URL;
        }else if(isLog){
            baseUrl = process.env.VUE_APP_LOG_URL;
        }else if(isRpt){
            baseUrl = process.env.VUE_APP_RPT_URL;
        }
        if (reqParam && reqParam.data && reqParam.data.baseUrl) {
            baseUrl = reqParam.data.baseUrl;
        }
        
        if(type == 'get'){
            return service({
                    url:reqParam.url,
                    method:"get",
                    params:reqParam.data,
                    baseURL:baseUrl
                }
            );
        }else if(type=="formdata"){
            return service({
                  url: reqParam.url,
                  method: "formdata",
                  data: reqParam.data,
                  headers: {
                      'Content-Type': 'multipart/form-data'
                  },
                  baseURL:baseUrl
              }
            );
        }
        return service({
                url:reqParam.url,
                method:"post",
                data:reqParam.data,
                baseURL:baseUrl
            }
        );
    }
}

export default queryApi